import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Stream from 'flarum/utils/Stream';

import UploadComponent from '../UploadComponent';
import setInputError from "../../common/util/setInputError";
import showAlert from '../../common/util/showAlert';
import SiteInfoRequestSuccessModal from './SiteInfoRequestSuccessModal';
import CaptchaComponent from '../CaptchaComponent';

export default class SiteInfoTouRongServiceModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.item = {};
    this.item.option_gsmc = Stream("");
    this.item.option_xmmc = Stream("");
    this.item.option_rzje = Stream("");
    this.item.option_zsxm = Stream("");
    this.item.option_zsxm_title = Stream(0);
    this.item.option_lxdh = Stream("");
    this.item.option_lxdh_checked = Stream(0);
    this.item.option_lxdh_wx_value = Stream("");
    this.item.option_lxdh_wx_value_disabled = Stream(true);
    this.item.option_rzsqs = Stream([]);
    this.u2diCaptcha = Stream("");
    this.trfwEnabled = app.forum.attribute("trfwEnabled");
  }

  className() {
    return 'Modal--large';
  }

  title() {
    return (
      <span style="font-size:24px;font-weight:bold">
        投融服务
      </span>
    );
  }

  onready() {
    const _this = this;
    $('input[type=radio][name=option_lxdh_checked]').on('change', function() {
      let value = parseInt($(this).val());
      _this.item.option_lxdh_checked(value);
      _this.item.option_lxdh_wx_value_disabled(value===0);
      _this.item.option_lxdh_wx_value(value===1?"":_this.item.option_lxdh());
      m.redraw();
    });

    $('input[type=radio][name=option_zsxm]').on('change', function() {
      _this.item.option_zsxm_title(parseInt($(this).val()));
    });

    let height = 360;
    let width = height*16/9;
    let spaceWidth = $(".Modal-body").width();

    if(width>spaceWidth){
      width = spaceWidth;
      height = width*9/16;
    }

    $("#u2diIframeVideo").css("width",width)
    $("#u2diIframeVideo").css("height",height)
  }

  content() {

    return (
      <div className="Modal-body ">
        <div className="Form" style="color:var(--text-color)">
          <p style="text-align: center;">
            <iframe id="u2diIframeVideo" style="margin-bottom:20px;" src="//player.bilibili.com/player.html?aid=403674754&bvid=BV1rV411K7fL&cid=1203689660&page=1&autoplay=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
          </p>
          <p style="font-size: 18px;font-weight:bold;">
            请确保您是融资企业的法人或实控人，否则请不要提交该表单。
          </p>
          <div style="padding-bottom:20px;font-size: 14px;color:gray;">
            <p>我们基于「优土地」平台优势，汇聚众多投资机构，为建设工程项目提供聚合的融资服务。</p>
            <p>在收到您的融资申请后，我们将对您的融资需求进行人工核实（请准备好关于项目尽量详尽的文件及资料）。初步评估后，我们会将您的融资需求信息，提交给我们众多合作的投资机构，若有投资机构对您的项目有意向，则由这些机构再行跟进。</p>
          </div>
          <p style="font-size: 18px;font-weight:bold;">
            服务优势：
          </p>
          <div style="padding-bottom:20px;font-size: 14px;color:gray;">
            <p>1，机构集群：您的融资需求将直达我们合作的多家投资机构进行评估，节省您的时间。</p>
            <p>2，概率增大：如果同时有多家投资机构对您的项目有意向，您能成功融资的概率也会更大。</p>
            <p>3，无前期费用：在贵企业未能成功签署融资合同前，我方「优土地」不会向您收取任何费用。</p>
            <div style="font-size: 12px;">注1：由于每个融资机构的情况不同，我们不保证融资机构是否会有一些前置费用，需您自行判断。</div>
            <div style="font-size: 12px;">注2：在我们向投资机构提交资料前，我方「优土地」需与贵企业签订居间服务协议。</div>
          </div>
          <p style="font-size: 18px;font-weight:bold;">
            机构合作：
          </p>
          <div style="padding-bottom:20px;font-size: 14px;color:gray;">
            <div>欢迎靠谱的投资机构与我们联系，贵机构需满足：成立至少5年，有可查的成功投资案例。</div>
            <div>合作联系：13205719527（同微信）</div>
          </div>

          <p style="font-size: 18px;font-weight:bold;text-align:center">
            融资申请
          </p>

          <p style="font-weight:bold;">
            <span style="font-size:15px">第一步：</span><span style="font-size:12px">下载“融资申请书模版”，填写、盖章、扫描</span>
          </p>
          <p style="margin-left: 60px;margin-bottom: 20px;">
            {Button.component({
                style: "font-size: 12px;height: 30px;line-height: 0px;",
                className: 'Button Button--primary',
                disabled: this.loading || this.trfwEnabled===false,
                onclick: () => {
                  window.open('./assets/extensions/ziiven-u2di/融资申请书模版.doc','_blank');
                }
              },
              "融资申请书模版"
            )}
          </p>

          <p style="font-weight:bold;">
            <span style="font-size:15px">第二步：</span><span style="font-size:12px">填写以下表单，并上传“融资申请书”扫描件</span>
          </p>

          <p style="margin-bottom: 20px;">
            <div>
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-gsmc')}：
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input id="option_gsmc" disabled={this.loading || this.trfwEnabled===false} required className="FormControl u2diUserSubmitItemInput" type="input" bidi={this.item.option_gsmc} />
                </div>
              </div>
            </div>

            <div style="padding-top: 10px;">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-xmmc')}：
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input id="option_xmmc" disabled={this.loading || this.trfwEnabled===false} required className="FormControl u2diUserSubmitItemInput" type="input" bidi={this.item.option_xmmc} />
                </div>
              </div>
            </div>

            <div style="padding-top: 10px;">
              <div className="u2diUserSubmitCategoryItems">
                <div className="u2diUserSubmitCategoryItemName">
                  {app.translator.trans('ziven-u2di.forum.user-submission-category-item-rzje')}：
                </div>
                <div className="u2diUserSubmitCategoryItemOptions">
                  <input id="option_rzje" disabled={this.loading || this.trfwEnabled===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.01" min="0.01" bidi={this.item.option_rzje} />
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-money-10k')}</span>
                </div>
              </div>
            </div>

            <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zsxm')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input id="option_zsxm" disabled={this.loading || this.trfwEnabled===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.item.option_zsxm} />
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                  <input disabled={this.loading || this.trfwEnabled===false} className="u2diUserSubmitCategoryItemRadio" id="zsxm_title0" type="radio" name="option_zsxm" value="0" checked={this.item.option_zsxm_title()==0?"checked":""} /><label style="margin-left: 5px;" for="zsxm_title0">{app.translator.trans('ziven-u2di.forum.option-zsxm-0')}</label>
                  <input disabled={this.loading || this.trfwEnabled===false} className="u2diUserSubmitCategoryItemRadio" id="zsxm_title1" type="radio" name="option_zsxm" value="1" checked={this.item.option_zsxm_title()==1?"checked":""} /><label style="margin-left: 5px;" for="zsxm_title1">{app.translator.trans('ziven-u2di.forum.option-zsxm-1')}</label>
                </div>
              </div>
            </div>

            {this.item.option_zsxm()!=="" && (this.item.option_zsxm().length<2 || this.item.option_zsxm().length>4) && (
              <div className="u2diUserSubmitCategoryItems ">
                <div className="u2diUserSubmitCategoryItemName">
                </div>
                <div style="color:var(--alert-error-bg)" className="u2diUserSubmitCategoryItemOptions">
                  真实姓名长度需要在2-4个字之间
                </div>
              </div>
            )}

            <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-lxdh')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input maxlength="11" id="option_lxdh" disabled={this.loading || this.trfwEnabled===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.item.option_lxdh} />
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                  <input disabled={this.loading || this.trfwEnabled===false} className="u2diUserSubmitCategoryItemRadio" id="lxdh_wx0" type="radio" name="option_lxdh_checked" value="0" checked={this.item.option_lxdh_checked()==0?"checked":""} /><label style="margin-left: 5px;" for="lxdh_wx0">{app.translator.trans('ziven-u2di.forum.option-lxdh-wx-0')}</label>
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1" style="padding-top: 0px;">
                  <input disabled={this.loading || this.trfwEnabled===false} className="u2diUserSubmitCategoryItemRadio" id="lxdh_wx1" type="radio" name="option_lxdh_checked" value="1" checked={this.item.option_lxdh_checked()==1?"checked":""} /><label style="margin-left: 5px;" for="lxdh_wx1">{app.translator.trans('ziven-u2di.forum.option-lxdh-wx-1')}</label>
                  <input maxlength="11" id="option_lxdh_wx_value" disabled={this.loading || this.trfwEnabled===false || this.item.option_lxdh_wx_value_disabled()} required style="margin-left: 15px;" className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.item.option_lxdh_wx_value} />
                 </div>
              </div>
            </div>

            <div style="padding-top: 5px;align-items: flex-start;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-scrzsqs')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <UploadComponent uploadLimit="2" disabled={this.loading || this.trfwEnabled===false} uploadType="option_rzsqs" uploadTarget={this.item.option_rzsqs} uploadCallback={function(result,option_target){
                    _this.item.option_rzsqs = option_target;
                }} />
              </div>
            </div>

            <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.captcha-validation')}
              </div>
              <div style="display: flex;" className="u2diUserSubmitCategoryItemOptions">
                <input id="u2diCaptcha" disabled={this.loading || this.trfwEnabled===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="input" maxlength="4" bidi={this.u2diCaptcha} />
                <CaptchaComponent />
              </div>
            </div>
          </p>

          <p style="font-weight:bold;">
            <span style="font-size:15px">第三步：</span><span style="font-size:12px">请加微信 13205719527 在线沟通</span>
          </p>

          {this.trfwEnabled===false && (
            <p style="color:red;text-align:center">
              投融服务暂停申请
            </p>
          )}

          <div style="text-align:center;margin-top: 30px;">
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading || this.trfwEnabled===false,
                onclick: (e) => {
                  this.submitData(e);
                }
              },
              app.translator.trans('ziven-u2di.lib.submit')
            )}&nbsp;
            {Button.component({
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  checkSubmitData(){
    //
    const wrapData = this.item;
    let isValid = true;

    for(let index in wrapData){
      if(typeof(wrapData[index])!=="function"){
        continue;
      }

      if((wrapData[index]()).length===0 && $("#"+index).length>0 && $("#"+index).prop('disabled')!==true){
        setInputError("#"+index,isValid);
        isValid = false;
      }
    }
    
    if((this.item.option_zsxm().length)<2 || (this.item.option_zsxm().length)>4){
      setInputError("#option_zsxm",isValid);
      isValid = false;
    }

    return isValid;
  }

  submitData(e) {
    e.preventDefault();

    if(this.checkSubmitData()===false){
      showAlert(app.translator.trans('ziven-u2di.forum.error-input-empty'));
      return;
    }

    this.loading = true;
    
    const submitData = {
      type: "trfw",
      u2diCaptcha:this.u2diCaptcha(),
      data:JSON.stringify({
        option_gsmc:this.item.option_gsmc(),
        option_xmmc:this.item.option_xmmc(),
        option_rzje:this.item.option_rzje(),
        option_zsxm:this.item.option_zsxm(),
        option_zsxm_title:this.item.option_zsxm_title(),
        option_lxdh:this.item.option_lxdh(),
        option_lxdh_wx_value:this.item.option_lxdh_checked()===0?this.item.option_lxdh():this.item.option_lxdh_wx_value(),
        option_rzsqs:this.item.option_rzsqs(),
      }),
    };

    app.store
        .createRecord("u2diRequest")
        .save(submitData)
        .then((returnData) => {
            app.modal.show(SiteInfoRequestSuccessModal,{requestType:submitData.type});
          }
        )
        .catch((e) => {
          this.loading = false;
          $(".u2diCaptcheImage").click();
        });

  }
}
